// Types
import type { NewFeatureReleasedType } from '@/lib/releases/newFeaturesReleased';
// Libs
import NEW_FEATURES_RELEASED from '@/lib/releases/newFeaturesReleased';

export const NEW_FEATURE_NOTIFICATIONS_LOCAL_STORAGE_KEY = 'new-feature-notifications';

const defaultValue = [];

export const getLocalStorageNewFeatureNotification = () => {
    const valueLocalStorage = localStorage.getItem(NEW_FEATURE_NOTIFICATIONS_LOCAL_STORAGE_KEY);
    return (
        valueLocalStorage ? JSON.parse(valueLocalStorage) : defaultValue
    ) as NewFeatureReleasedType['name'][];
};

export const setLocalStorageNewFeatureNotification = (value: NewFeatureReleasedType['name'][]) => {
    // INFO : Remove old notifications
    const possibleNewFeatures = NEW_FEATURES_RELEASED.map((feature) => feature.name);
    const featuresToInsert = value.filter((feature) => possibleNewFeatures.includes(feature));

    // INFO : Remove key in local storage if empty
    if (featuresToInsert.length === 0) {
        localStorage.removeItem(NEW_FEATURE_NOTIFICATIONS_LOCAL_STORAGE_KEY);
        return;
    }
    localStorage.setItem(
        NEW_FEATURE_NOTIFICATIONS_LOCAL_STORAGE_KEY,
        JSON.stringify(featuresToInsert)
    );
};
